/**
 * Destini "Where to buy" widget loader.
 *
 * It only initialises once per page load, so all UPCs are passed up front and
 * the widget is never re-rendered.
 *
 * The widget opens its overlay inside a shadow root with a z-index the navbar
 * (9999) outranks. Since we can't style inside the shadow root, the wrapper is
 * raised above the navbar only while the overlay is open.
 */

const WRAPPER_SELECTOR = '.product-overview__details__destini';
const CONTAINER_SELECTOR = '.destini-locator-class';
const OVERLAY_SELECTOR = '[role="dialog"], [class*="modal__overlay"]';
const OPEN_CLASS = 'opened';

const SHADOW_POLL_MS = 100;
const SHADOW_POLL_MAX = 100;

function watchOverlay(wrapper, container) {
  const root = container.shadowRoot;
  let opened = false;
  let frame = null;

  function sync() {
    frame = null;

    const isOpened = !!root.querySelector(OVERLAY_SELECTOR);

    if (isOpened !== opened) {
      opened = isOpened;
      wrapper.classList.toggle(OPEN_CLASS, isOpened);
    }
  }

  function schedule() {
    if (frame === null) {
      frame = window.requestAnimationFrame(sync);
    }
  }

  new MutationObserver(schedule).observe(root, {
    childList: true,
    subtree: true,
  });

  sync();
}

function whenShadowReady(container, callback) {
  let tries = 0;

  const timer = setInterval(function () {
    tries += 1;

    if (container.shadowRoot) {
      clearInterval(timer);
      callback();
    } else if (tries >= SHADOW_POLL_MAX) {
      clearInterval(timer);
    }
  }, SHADOW_POLL_MS);
}

window.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector(WRAPPER_SELECTOR);
  const container = wrapper ? wrapper.querySelector(CONTAINER_SELECTOR) : null;

  if (!container || !container.dataset.apo || !container.dataset.snippetUrl) {
    return;
  }

  const snippet = document.createElement('script');
  snippet.charset = 'utf-8';
  snippet.src = container.dataset.snippetUrl;
  document.body.appendChild(snippet);

  whenShadowReady(container, function () {
    watchOverlay(wrapper, container);
  });
});
